class StepCounter extends HTMLElement{
    constructor(){
        super()
        this.cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.button = this.querySelector('.button-component')
        this.template = this.button.dataset.template
        this.cart = JSON.parse(this.querySelector('#cartInfo').textContent)
        this.button.addEventListener('click', this.handleClick.bind(this))
        this.stepsNav= this.querySelector('.steps_counter--nav')
        this.active = this.querySelector('.steps_counter--nav .active')

        // Desplaza hasta el elemento activo
        if (this.active) {
            this.stepsNav.scrollLeft = this.active.offsetLeft - (this.stepsNav.offsetWidth - this.active.offsetWidth) / 2;
        }

        this.headerLogo = document.querySelector('.header__heading-link')
        this.headerLogo.addEventListener('click', (e)=>{
            if(localStorage.getItem('selectedCase')){
                var warningMessage = 'Changes you made may not be saved.'
                if (!confirm(warningMessage)) e.preventDefault();
            }
        })
    }
    clearLocalStorage(){
        localStorage.clear()
    }

    handleClick(event){
        event.preventDefault()
        if(this.template == 'step_1') {this.handleStep1()}
        if(this.template == 'step_2') {this.handleStep2()}
        if(this.template == 'step_3') {this.handleStep3()}
        if(this.template == 'step_4') {this.handleStep4()}
        if(this.template == 'step_5') {this.handleStep5()}
    }
    async handleStep1(){
        let selectedCase = JSON.parse(localStorage.getItem('selectedCase'))
        selectedCase ? this.enableButton() : console.log('please, select a case')
    }
    async handleStep2(){
        let selectedSuscription = JSON.parse(localStorage.getItem('selectedSuscription'))
        let checkedSuscription = JSON.parse(localStorage.getItem('checkedSuscription'))
        if(selectedSuscription != '' && checkedSuscription == true){
            this.enableButton();
        }
        if(checkedSuscription == false){
            this.enableButton()   
        }
    }

    async handleStep3(){
        let selectedPack = JSON.parse(localStorage.getItem('selectedPack'))
        const selectedPackQuantity = localStorage.getItem('selectedPackQuantity')
        const minimumQty = localStorage.getItem('minimumQty')
        let modifiedSelectedPack = selectedPack.filter(item=>item.quantity > 0);
        /*const addData = {
            items: modifiedSelectedPack
        }*/
        (selectedPack && selectedPackQuantity >= minimumQty) ? this.enableButton() :  console.log('please choose a scent')

    }
    async handleStep4(){
        let selectedAddons = JSON.parse(localStorage.getItem('selectedAddons'))
        if(selectedAddons != ''){
         this.enableButton()
        }
         
    }
    async handleStep5(){
        let items = new Array()
        let selectedCase = JSON.parse(localStorage.getItem('selectedCase'))

        let selectedPack = JSON.parse(localStorage.getItem('selectedPack'))
        let modifiedSelectedPack = selectedPack? selectedPack.filter(item=>item.quantity > 0) : null;

        let selectedSuscription = JSON.parse(localStorage.getItem('selectedSuscription'))
        let checkedSuscription = JSON.parse(localStorage.getItem('checkedSuscription'))
        if(selectedSuscription != '' && checkedSuscription != false){
            modifiedSelectedPack.map(variant=>variant.selling_plan = selectedSuscription)
        }
        if(selectedSuscription != '' && checkedSuscription == false){
            modifiedSelectedPack.map(variant=>variant.id = variant.otId)
        }
        let selectedAddons = JSON.parse(localStorage.getItem('selectedAddons'))

        let selectedTravelBag = JSON.parse(localStorage.getItem('selectedTravelBag'))
        
        items.push(selectedCase)
        items.push(modifiedSelectedPack)

        if(selectedAddons != '' || selectedAddons.length > 0){
            items.push(selectedAddons)
        }
        if(selectedTravelBag != '' || selectedTravelBag.length > 0){
            items.push(selectedTravelBag)
        }
   

        let finalItems = items.reduce((accumulator, currentElement) => {
            return accumulator.concat(currentElement);
        }, []);

        let filteredItems = finalItems.filter(item => {
            if (typeof item === 'object' && item !== null) {
                if (Array.isArray(item)) {
                    return item.every(subItem => typeof subItem === 'object' && subItem !== null && subItem.hasOwnProperty('id'));
                } else {
                    return item.hasOwnProperty('id');
                }
            } else {
                return true;
            }
        });
        
        console.log(filteredItems)
        const data = {
            items: filteredItems
        }

        const dataFetching = await this.handleFetch(data)
        if(dataFetching.res.ok){
            //console.log('items added, starting to check discount code')
            this.cartDrawer.applyDiscountCode('8AQCSBPZ3E25')
            setTimeout(()=>{
               //window.location = this.button.href
               //this.clearSelection()   
            },5000)
        }else{
            console.log('items not added')
        }
        

    }

    async handleFetch(body, endpoint='add'){
        try {
            const res = await fetch(`/cart/${endpoint}.js`, {
                body: JSON.stringify(body),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                },
                method: 'POST'
              })
                
                const data = await res.json()
                return {res, data}
            
            //window.location = this.button.href
        } catch (error) {
            console.log(error.message)
        }
        finally{
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            this.clearLocalStorage()
        }
    }

    enableButton(){
        window.location = this.button.href
    }
    clearSelection(){
        localStorage.removeItem('selectedCase')
        localStorage.removeItem('selectedAddons')
        localStorage.removeItem('selectedTravelBag')
        localStorage.removeItem('checkedSuscription')
        localStorage.removeItem('selectedSuscription')
        localStorage.removeItem('selectedPack')
        localStorage.removeItem('selectedPackQuantity')
    }
}
customElements.define('step-counter', StepCounter)